import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class OutboxMonitorService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getSummary() {
        try {
            const body = await withRetry(() => this.api.getSummary(), { maxRetries: 2 });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Outbox özeti alınamadı');
        }
    }

    async list(params = {}) {
        try {
            const body = await withRetry(() => this.api.list(params), { maxRetries: 2 });
            return {
                success: body.success !== false,
                data: body.data,
                meta: body.meta || {},
                message: body.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Outbox listesi alınamadı');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
